<form [formGroup]="form" class="flex flex-column gap-4">

    <!-- Assistant qui demande l'accès -->
    <div>
        <div class="text-xl font-medium mb-3">
            Connecter {{ authorizationRequest.assistant.name }} à Biifor
        </div>
        <div class="text-sm">
            <span class="font-semibold">{{ authorizationRequest.assistant.name }}</span> demande à accéder à un
            dossier Biifor en votre nom.
        </div>
    </div>

    <!-- Dossier autorisé -->
    @if (authorizationRequest.clients.length > 1) {
    <div class="flex flex-column gap-2">
        <label for="client" class="text-sm font-medium">Dossier</label>
        <p-select inputId="client" [options]="authorizationRequest.clients" formControlName="client"
            optionLabel="commercialName" dataKey="id" placeholder="Choisissez un dossier..." appendTo="body"
            styleClass="w-full">
            <ng-template let-client #item>
                <div class="flex align-items-center gap-2">
                    <span>{{ client.commercialName }}</span>
                    @if (client.demo) {
                    <p-tag value="Démo" severity="secondary" [rounded]="true"></p-tag>
                    }
                </div>
            </ng-template>
        </p-select>
    </div>
    } @else {
    <div class="flex flex-column gap-2">
        <span class="text-sm font-medium">Dossier</span>
        <div class="flex align-items-center gap-2">
            <span class="font-semibold">{{ authorizationRequest.clients[0].commercialName }}</span>
            @if (authorizationRequest.clients[0].demo) {
            <p-tag value="Démo" severity="secondary" [rounded]="true"></p-tag>
            }
        </div>
    </div>
    }

    <!-- Ce que l'utilisateur accorde -->
    <app-message severity="secondary" icon="pi pi-shield" class="block" title="Ce que vous autorisez"
        [messages]="grantedScope">
    </app-message>

    <!-- Décision -->
    <div class="flex gap-2">
        <p-button type="button" label="Autoriser" icon="pi pi-check" [rounded]="true" [disabled]="!canSave()"
            [loading]="loading" (click)="onClickSave()"></p-button>
        <p-button type="button" label="Refuser" severity="secondary" [outlined]="true" [rounded]="true"
            [disabled]="loading" (click)="onClickRefuse()"></p-button>
    </div>
</form>
